import styled from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';

export default styled(Button).attrs(({ $isOpen }) => ({
  wrapper: true,
  nav: true,
  navType: 'hamburger_menu',
  menuName: 'Main menu',
  eventAction: $isOpen ? 'close' : 'open',
}))`
  display: flex;
  align-items: center;
  background-color: transparent;
  border-radius: ${(props) => props.theme.borderRadius};
  border: 1px solid ${(props) => props.theme.gray2};
  padding: 6px 10px;
  text-transform: uppercase;
  font-family: ${(props) => props.theme.standoutFontFamily};
  font-weight: 700;
  cursor: pointer;

  svg {
    width: 27px;
    height: auto;
    color: ${(props) => props.theme.primaryColor};
    margin-left: 10px;
  }
  &:hover {
    background-color: ${(props) => props.theme.gray4};
    color: white;
    svg {
      color: white;
    }
  }
  @media all and (min-width: ${(props) => props.theme.breakingpoints.xl}) {
    display: none;
  }
`;
